import type { IGatsbyImageData } from 'gatsby-plugin-image';
import ArrowIcon from '../../atoms/arrow';
import * as s from './styles';
import type { IFeatureCard } from './types';

const FeatureCard = ({ 
  image,
  headline,
  subhead,
}: IFeatureCard) =>  (
  //@ts-ignore: tabindex
  <s.StyledFeatureCard  tabIndex={0} data-feature-card>
    <s.ImageContainer>
      <s.StyledImage imageData={image?.gatsbyImage as IGatsbyImageData} altText={image?.altText}/>
    </s.ImageContainer>
    <s.TextContainer>
      <s.Headline>
        {headline}
      </s.Headline>
      <s.Text>
        {subhead}
      </s.Text>
      <ArrowIcon />
    </s.TextContainer>
  </s.StyledFeatureCard>
);

export default FeatureCard;
